// Page/component translations — French (fr)
export const pagesFr: Record<string, string> = {
  // COMMON
  loading: 'Chargement...',
  saving: 'Enregistrement...',
  deleting: 'Suppression...',
  processing: 'Traitement...',
  errorLabel: 'Erreur',
  successLabel: 'Succès',
  notAuthenticated: 'Utilisateur non authentifié',
  tryAgain: 'Réessayer',
  noData: 'Aucune donnée disponible',
  copiedToClipboard: 'Copié dans le presse-papiers',
  requiredField: 'Champ obligatoire',
  invalidEmailMsg: 'Email invalide',
  loadingVideos: 'Chargement des vidéos...',
  noVideosFound: 'Aucune vidéo trouvée',
  unknownError: 'Erreur inconnue',
  confirmDelete: 'Confirmer la suppression',
  saveError: 'Erreur lors de la sauvegarde',
  loadingEllipsis: 'Chargement...',
  loadingDataEllipsis: 'Chargement des données...',

  // AUTH
  loginTitle: 'Accédez à votre compte',
  loginSubtitle: 'Tout pour développer vos VSLs avec automatisation, protection et métriques.',
  loginSuccess: 'Connexion réussie !',
  loginError: 'Erreur de connexion. Vérifiez vos identifiants.',
  loginErrorGeneric: 'Erreur de connexion. Réessayez.',
  enterButton: 'Se connecter',
  enteringButton: 'Connexion...',
  stayConnected: 'Rester connecté',
  forgotPassword: 'Mot de passe oublié ?',
  noAccount: "Vous n'avez pas de compte ?",
  createAccountFree: 'Créez votre compte gratuitement ici maintenant',
  signupTitle: 'Créez votre compte',
  signupSubtitle: 'Et commencez à transformer les vidéos en conversions réelles.',
  signupSuccess: 'Compte créé avec succès ! Choisissez maintenant votre plan pour commencer.',
  signupError: 'Erreur lors de la création du compte. Réessayez.',
  acceptTermsError: "Vous devez accepter les conditions d'utilisation pour continuer.",
  passwordError: 'Les mots de passe doivent être identiques.',
  userAlreadyExists: 'Cet utilisateur a déjà un compte sur la plateforme.',
  nameTooShort: 'Le nom doit avoir au moins 2 caractères.',
  invalidCPF: 'CPF invalide.',
  invalidWhatsApp: 'WhatsApp invalide.',
  passwordTooShort: 'Le mot de passe doit avoir au moins 8 caractères.',
  alreadyHaveAccount: 'Vous avez déjà un compte ?',
  loginHereLink: 'Connectez-vous ici',
  namePlaceholder: 'Nom complet',
  emailPlaceholder: 'votremail@domaine.com',
  passwordPlaceholder: 'Min. 8 caractères',
  emailLabel: 'Email',
  passwordLabel: 'Mot de passe',
  acceptTermsLabel: "J'accepte les conditions d'utilisation et la politique de confidentialité",

  // DASHBOARD / MY VIDEOS
  deleteVideoSuccess: 'Vidéo supprimée avec succès !',
  deleteVideoError: 'Erreur lors de la suppression de la vidéo',
  moveVideoSuccess: 'Vidéo déplacée vers le dossier avec succès !',
  moveVideoError: 'Erreur lors du déplacement de la vidéo',
  videoRemovedFromFolder: 'Vidéo retirée du dossier !',
  searchVideosPlaceholder: 'Rechercher des vidéos...',
  noVideosInFolder: 'Aucune vidéo dans ce dossier',
  newFolderLabel: 'Nouveau dossier',
  gridViewLabel: 'Vue en grille',
  listViewLabel: 'Vue en liste',
  myVideosPageTitle: 'Mes Vidéos',
  manageVideosSubtitle: 'Gérez et visualisez vos dernières vidéos',

  // A/B TEST
  incompleteConfig: 'Configuration incomplète',
  mainVideoNotSelected: 'Vidéo principale non sélectionnée',
  abTestActive: 'Votre test A/B est actif',
  videoSelectionTab: 'Sélection de vidéos',
  trafficDistributionTab: 'Distribution du trafic',
  testDeletedMsg: 'Test supprimé',
  cannotDeleteTest: 'Impossible de supprimer le test',
  createFirstABTest: 'Créez votre premier test A/B',
  abTestEmptyDesc: 'Testez différentes versions de vos VSLs et découvrez ce qui convertit le plus',
  createABTestBtn: 'Créer un Test A/B',
  howItWorksLink: 'Comment ça marche ?',
  trafficUpdatedSuccess: 'Distribution mise à jour',
  trafficUpdatedDesc: 'La distribution du trafic a été mise à jour avec succès',
  selectMinVideos: 'Sélectionnez au moins 2 vidéos pour le test',
  selectMaxVideos: 'Sélectionnez au maximum 6 vidéos pour le test',
  dateNotAvailable: 'Date non disponible',
  invalidDate: 'Date invalide',
  runningStatus: 'En cours',
  finishedStatus: 'Terminé',
  authError: "Erreur d'authentification",

  // HOOK TRACK
  hookTestActive: "Votre test d'introduction est actif",
  hookTrackEmptyDesc: "Testez différentes introductions et découvrez laquelle retient le plus l'attention",
  createFirstHookTest: "Créez votre premier test de hook",

  // VSLEADS
  loadStrategiesError: 'Erreur lors du chargement des stratégies',
  strategyUpdatedToast: 'Stratégie mise à jour',
  strategyUpdatedSuccessMsg: 'La stratégie a été mise à jour avec succès.',
  strategyRemovedToast: 'Stratégie supprimée',
  loadingStrategies: 'Chargement des stratégies...',
  leadCaptureTitle: 'Capture de Leads',
  captureWithEmailLabel: 'Capture avec Email',
  captureWithPasswordLabel: 'Capture avec Mot de Passe',
  loadStrategyError: 'Erreur lors du chargement de la stratégie',
  strategyUpdateSuccess: 'Stratégie mise à jour avec succès',
  updateStrategyError: 'Erreur lors de la mise à jour de la stratégie',
  protectedContent: 'Contenu protégé',
  accessVideoBtn: 'Accéder à la vidéo',
  strategyCreated: 'Stratégie créée avec succès',
  saveStrategyError: 'Erreur lors de la sauvegarde de la stratégie',

  // VSL CLOAKER
  loadVideosError: 'Erreur lors du chargement des vidéos',
  loadRulesError: 'Erreur lors du chargement des règles',
  selectOriginalVideo: 'Sélectionnez la vidéo originale',
  ruleCreated: 'Règle créée avec succès',
  ruleDeleted: 'Règle supprimée avec succès',
  codesCopied: 'Code copié !',
  cloakerEmptyTitle: 'Aucune règle créée',
  cloakerEmptyDesc: 'Créez des règles pour filtrer et rediriger le trafic selon des critères',

  // UPLOAD
  invalidFormat: 'Format invalide',
  selectVideoFilesOnly: 'Sélectionnez uniquement des fichiers vidéo',
  videosAddedToast: 'Vidéos ajoutées',
  uploadsCompleted: 'Téléchargements terminés',
  maxFileSizeError: 'Le fichier doit faire au maximum 100MB',
  unsupportedFormatMsg: 'Format non supporté',
  videoNameLabel: 'Nom de la vidéo',
  continueToCustomize: 'Continuez pour personnaliser votre vidéo',
  myVideoDefault: 'Ma Vidéo',

  // METRICS
  noRetentionData: 'Aucune donnée de rétention dans la période',
  noUTMData: 'Aucune donnée UTM dans la période',
  expandPeriodTip: 'Essayez d\'élargir la période',
  saveErrorMsg: 'Erreur lors de la sauvegarde',
  videoTimeLabel: 'Temps de la Vidéo',
  retentionLabel: 'Rétention (%)',

  // PLAYLIST
  playlistDeletedMsg: 'Playlist supprimée',
  playlistLinkCopied: 'Lien de la playlist copié',
  playlistNotFound: 'Playlist non trouvée',
  videosAddedMsg: 'Vidéos ajoutées !',
  videoRemovedMsg: 'Vidéo supprimée',
  videosAddedSuccessDesc: 'Vidéos enregistrées avec succès.',
  embedCodeCopiedMsg: 'Code copié !',
  embedCodeCopiedDesc: 'Code d\'intégration copié dans le presse-papiers.',
  logoCompressed: 'Logo optimisé',
  logoError: 'Erreur lors de la compression du logo',
  faviconError: 'Erreur lors de la compression du favicon',
  addVideosTitle: 'Ajouter des vidéos',

  // SHARE VIDEO
  settingsSaved: 'Paramètres enregistrés !',
  generatingPublicLink: 'Génération du lien public',
  activatingMetrics: 'Activation des métriques',
  videoPreparing: 'Vidéo en préparation',
  copiesLabel: 'copies',
  copyLabel: 'copie',

  // WEBINAR
  invalidWhatsAppField: 'WhatsApp invalide',
  registrationSuccess: 'Inscription effectuée !',
  redirectingToRoom: 'Vous allez être redirigé vers la salle...',
  formError: 'Erreur dans le formulaire',

  // NOTIFICATIONS
  notificationsSaved: 'Préférences enregistrées',
  notificationsEnabled: 'Notifications activées !',
  notificationPermissionNeeded: 'Permission requise',
  testNotification: 'Notification de test',
  installAvailable: 'HostVSL est en cours d\'installation',
  installInfo: 'Vous pouvez accéder à HostVSL depuis votre écran d\'accueil',
  installNotAvailable: 'Installation non disponible',

  // FEATURE CONFIGS
  urlInvalid: 'URL invalide',
  unsupportedImageFormat: 'Format non supporté. Utilisez PNG ou JPG',
  thumbnailConfigured: 'Miniature de début configurée',
  buttonAdded: 'Bouton ajouté',
  buttonRemoved: 'Bouton supprimé',
  videoIdNotFound: 'ID de vidéo introuvable',

  // DASHBOARD EMPTY STATES
  emptyDashboardTitle: 'Aucune vidéo trouvée',
  emptyDashboardSubtitle: 'Téléchargez votre première vidéo pour commencer',
  uploadFirstVideo: 'Télécharger la première vidéo',

  // PROFILE
  profileSaved: 'Profil enregistré',
  passwordChangedSuccess: 'Mot de passe changé avec succès',
  photoChangedSuccess: 'Photo modifiée',
  photoRemovedSuccess: 'Photo supprimée',

  // PIXEL
  pixelPageTitle: 'Configuration du Pixel',
  pixelPageSubtitle: 'Configurez des pixels de suivi pour surveiller les conversions',

  // METRICS PAGE
  metricsPageTitle: 'Métriques',
  selectVideoMetrics: 'Sélectionnez une vidéo pour voir les métriques',

  // DOMAIN PROTECTION
  domainProtectionTitle: 'Protection de Domaine',

  // TRACKING
  trackingTitle: 'Suivi',

  // FINANCE
  financeTitle: 'Finance',

  // PARTNERS
  partnersTitle: 'Partenaires',

  // NOT FOUND
  pageNotFound: 'Page non trouvée',
  goHome: "Retour à l'accueil",

  // AB TEST LIST
  abTestListTitle: 'Vos Tests A/B',
  createNewTest: 'Créer un nouveau test',
  noABTestsFound: 'Aucun test A/B trouvé',
  createFirstABTestDesc: 'Créez votre premier test A/B pour comparer différentes versions de vidéos.',
  copyCode: 'Copier le Code',
  rename: 'Renommer',
  viewMetrics: 'Voir les Métriques',
  deleteABTestTitle: 'Supprimer le test A/B ?',
  deleteTestConfirm: 'Cette action supprimera définitivement ce test et toutes ses données. Cette action est irréversible.',
  confirmDeleteTest: 'Oui, supprimer le test',
  abTestCodeCopiedDesc: 'Le code du test A/B a été copié dans le presse-papiers.',
  abTestDeletedDesc: 'Le test A/B a été supprimé avec succès.',
  deleteErrorTitle: 'Erreur de suppression',
  testRenamedTitle: 'Test renommé',
  testRenamedDesc: 'Le nom du test a été mis à jour avec succès.',
  renameErrorTitle: 'Erreur de renommage',
  renameTestError: 'Impossible de renommer le test.',
  copyCodeErrorTitle: 'Erreur de copie du code',
  noVideosInTest: "Ce test n'a pas de vidéos associées.",
  featureInDevelopment: 'En développement',
  toggleStatusDev: "La fonction d'activation/désactivation est en développement.",
  duplicateDev: 'La fonction de duplication est en développement.',

  // HOOK TRACK LIST
  hookTrackListTitle: "Vos Tests d'Introduction",
  createHookTest: 'Créer un Test de Hook',
  noHookTestsDesc: "Vous n'avez pas encore créé de test de hook.",
  createFirstHookLabel: 'Créer votre premier test',
  deleteHookTestTitle: 'Supprimer le test de hook ?',
  hookTestDeletedDesc: 'Le test a été supprimé avec succès.',
  hookRenameTestError: 'Impossible de mettre à jour le nom du test.',
  statusUpdatedTitle: 'Statut mis à jour',
  statusUpdatedDesc: 'Le statut du test a été mis à jour.',
  duplicateSoon: 'Fonctionnalité de duplication bientôt disponible.',
  testWithoutName: 'Test sans nom',

  // MY VIDEOS V2
  removeFromFolderError: 'Erreur lors de la suppression de la vidéo du dossier',
};
